<template>
  <div style="width: 100%; height: 100%;">
    <mw-dialog ref="setValuesDialog" :footerButton="setButton" size="small_large" title="设置选项值">
      <dValues :dataId="form.id"  ref="valueChoose"></dValues>
    </mw-dialog>
    <first ref="unitTree" @confirm="deptChoose"></first>

    <div class="mw-toolbar">
      <el-button  type="primary" @click="handleClose"> <i class="fa fa-mail-reply "></i>  关闭</el-button>
      <el-button  type="primary" @click="saveDict"> <i class="fa fa-file-text"></i>  保存</el-button>
      <el-button @click="showHelp" type="info" style="float:right;margin-top: 8px;"><i class="fa fa-question"></i>帮助</el-button>
    </div>
    <div class="mw-toolbar__body" >
      <el-form :model="form" :label-position="labelPosition"  label-width="100px" :rules="formRules" ref="dataForm" style="margin-top:20px;">
        <el-col :span="24" v-show="false">
          <el-form-item label="类别" prop="catalog">
            <el-input v-model="form.catalog"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="数据名称" prop="name">
            <el-input :disabled="!isEditName" v-model="form.name"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-show="false">
          <el-form-item label="编码" prop="code">
            <el-input v-model="form.code"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="是否有效" prop="active">
            <el-radio-group v-model="form.active">
              <el-radio label="T">是</el-radio>
              <el-radio label="F">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="是否私有" prop="personal">
            <el-radio-group v-model="form.personal">
              <el-radio label="T">是</el-radio>
              <el-radio label="F">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-show="form.personal === 'T'">
          <el-form-item label="所属单位">
            <el-input type="textarea" :rows="2" v-model="form.unitName" style="width: 85%"></el-input>
            <el-button @click="showDialog('unitTree')">选择</el-button>
            <el-button @click="clearDept">清空</el-button>
          </el-form-item>
        </el-col>

        <el-col :span="24" v-show="false">
          <el-form-item label="所属单位">
            <el-input v-model="form.unitId"></el-input>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="选项类型" prop="types">
            <el-radio-group  @change="handleRadio" v-model="form.types">
              <el-radio label="0">值</el-radio>
              <el-radio label="1">设置选项值</el-radio>
              <el-radio label="2">文件</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="选 项 值 " prop="value">
            <template  v-if="form.types === '1'">
              <el-button type="primary" @click="addSetting">设置选项值</el-button>
            </template>
            <template v-else-if="form.types === '0'">
              <el-input v-model="form.value"></el-input>
            </template>
            <template v-else-if="form.types === '2'">
              <file-input v-model="form.value" :dict-id="form.id"></file-input>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="12"  prop="values" v-show="false">
          <el-form-item label="选项值" >
            <el-input v-model="form.values" ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-show="false">
          <el-form-item label="是否开放前台编辑" >
            <el-radio-group v-model="form.typeedit">
              <el-radio :label="1">开放</el-radio>
              <el-radio :label="2">不开放</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>


        <el-col :span="24">
          <el-form-item label="数据备注" prop="remark">
            <el-input type="textarea" :rows="4" v-model="form.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>
</template>

<script>
  import first from "./../../appModule/dict/firstDept.vue";
  import dValues from "./../../appModule/dict/dataValues.vue";

  export default {
    components: {
      first,
      dValues,
      "file-input": {
        props: {
          readOnly: {
            type: Boolean,
            default: false,
          },
          disabled: {
            type: Boolean,
            default: false
          },
          placeholder: {
            type: String,
            default: ''
          },
          value: {
            default: () => ({})
          },
          dictId: {
            type: String,
            default: ''
          }
        },
        template: `
      <el-input :placeholder="placeholder" :value="displayValue" :readOnly="true">
        <template  v-if="uploadable || downloadable">
          <el-button slot="append" v-if="uploadable">
            <label>
              上传
              <input type="file" style="display:none;" @change="handleChange" ref="input"/>
            </label>
          </el-button>
          <a style="display:block;height:100%;" href="javascript:void(0);" class="el-icon-download el-input__icon" slot="suffix" v-if="downloadable" @click="handleDownload">
          </a>
        </template>

      </el-input>
      `,
        computed: {
          displayValue() {
            return this.value && this.value.name || this.value || '';
          },
          downloadable() {
            return this.dictId;
          },
          uploadable() {
            return (!this.readOnly) && (!this.disabled);
          }
        },
        methods: {
          handleChange(e) {
            const files = this.mwRef('input').files;
            if (files[0]) {
              this.$emit('input', files[0]);
            }
          },
          async handleDownload(e) {
            if (this.dictId) {
              let appId=this.$route.params.appId;
              const response = await this.mwUtil.downloadAttachment2({
                url: '/api/data/getDictFile',
                params: {
                  jsonData: JSON.stringify([this.dictId,appId])
                },
              });
              if (response && response.msg) {
                this.mwMsg('waring', response.msg);
              }
            }
          }
        }
      }
    },
    props: {
        params: {
            type: Object
        }
    },
    watch: {
      params: {
        handler: function(newValue, oldValue){
          debugger;
          if (newValue) {
            if (newValue.form) this.form = newValue.form;
          }
        },
        deep: true
      }
    },
    data() {
      return {
        pagination:false,
        labelPosition:'left',
        appId:this.getParams().appId,
        sysId:this.getParams().sysId,
        form: {
          catalog: "",
          name: "",
          active: "T",
          personal: "F",
          atrrs: "S",
          types: "0",
          typeedit: 2,
          values: "",
          value:"",
          applicationId:'',
          owner:'',
          codeContent: '',
          remark: "",
          unitName: "",
          unitId: "",
          code: ''
        },
        formRules: {
          name: [{ required: true, message: "请输入名称", trigger: "blur" }],
          value: [{ required: true, message: "请输入或选择值", trigger: "blur" }]
        },
        setButton: [
          {
            label: "确定",
            func: this.chooseSure
          },
          {
            label: "取消",
            type: "default",
            func: this.cancel
          }
        ],
        isEditName: false
      }
    },
    mounted:function() {
        var me=this;
        // if (me.params.form) me.mwUtil.applyCover(me.form, me.params.form);
        debugger;
        me.isEditName = !me.params.isEditName ? false : true;
    },
    methods: {
      saveDict() {
        if (this.form.personal === "F") {
          this.clearDept();
        }
        if (this.form.types == "1") {
          this.$set(this.form, 'value',this.form.codeContent);
        }
        this.mwRef("dataForm").validate(valid => {
          if (valid) {
           // delete this.form.value;
            if (this.form.types != "0") {
              this.form.values = '';
            } else {
              this.form.codeContent ='';
            };
            this.form.applicationId=this.$route.params.appId;
            this.form.owner=this.$route.params.sysId;
            let me=this;
            this.mwApi.data.saveDict(this.form).then(res => {
              if (res.success) {
                this.mwMsg("info", "保存成功");
                this.refreshTable();
                this.handleClose();
              }
            });
          }else{
            this.mwMsg("信息未填写完整");
          }
        });
      },
      handleRadio() {
        if (this.types != "0") {
          this.mwRef("dataForm").clearValidate();
        }
      },
      handleClose() {
        this.resetFields();
        this.form.name = "";
        this.form.values = "";
        this.form.value = "";
        // this.form.catalogContent = "";
        this.form.codeContent = "";
        this.mwRef("titleTree").hide();
      },
      addSetting(){
        this.showDialog('setValuesDialog');
      },
      chooseSure() {
        let data =this.mwRef('valueChoose').getValue();
        this.form.codeContent =  JSON.stringify(data);
        this.mwRef("setValuesDialog").hide();
      },
      cancel() {
        this.mwRef("setValuesDialog").hide();
      },
      clearDept() {
        this.form.unit = "";
        this.form.unitName = "";
      },
      resetFields() {
        this.mwRef("dataForm").resetFields();
      },
      showDialog(a) {
        this.mwRef(a).show();
      },
      getParams(){
        return this.$route.params;
      },
      deptChoose(data) {
        let unit = [];
        let unitIds = [];
        data.forEach(d => {
          unit.push(d.name);
          unitIds.push(d.id);
        });

        this.form.unitName = unit.join();
        this.form.unitId = unitIds.join();
      },
      showHelp:function(){
        PF.showHelp({url:'/helpDoc/platform/dict.md'})
      }
    }
  }
</script>

<style scoped>
  .pre-class {
    display: block;
    padding: 9.5px;
    margin: 0 0 10px;
    font-size: 13px;
    line-height: 1.42857143;
    color: #333;
    word-break: break-all;
    word-wrap: break-word;
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/org/dataDicEdit.vue